export default {
	pageTitle(state) {
		return state.currentPageTitle;
	},

	showLoaderStatus(state) {
		return state.showLoader;
	}
}


// WEBPACK FOOTER //
// ./src/store/getters.js